import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { ErpObject } from './types';

export const evaluateErpNumber = (entity: Entities, data: ErpObject) => {
  return entity === Entities.contract ? data?.contractNumber : data?.number;
};

export const getInitialBusinessPartner = (data: ErpObject[]) =>
  data.length
    ? data?.[0]?.businessPartnerContactCombined?.businessPartner?.data
    : undefined;

export const isGroupingEnabled = (
  sourceEntity: Entities,
  targetEntity: Entities
) => sourceEntity === Entities.contract && targetEntity === Entities.order;

export const calculateErpNumber = (
  sourceEntity: Entities,
  data: ErpObject[]
) => {
  if (data.length === 1) {
    return `${evaluateErpNumber(sourceEntity, data[0])}`;
  }
  return (
    data
      .slice(1, 5)
      .reduce(
        (prev, entry) => `${prev}, ${evaluateErpNumber(sourceEntity, entry)}`,
        `${evaluateErpNumber(sourceEntity, data[0])}`
      ) + (data.length > 5 ? '...' : '')
  );
};

export const isContractToDeliveryNote = (
  sourceEntity: Entities,
  targetEntity: Entities
) =>
  (sourceEntity === Entities.order &&
    targetEntity === Entities.inboundDeliveryNote) ||
  (sourceEntity === Entities.contract &&
    targetEntity === Entities.deliveryNote);

export const isContractToOrder = (
  sourceEntity: Entities,
  targetEntity: Entities
) => sourceEntity === Entities.contract && targetEntity === Entities.order;

export const isSingleBusinessPartner = (data: ErpObject[]) =>
  new Set(
    data
      .map((x) => x?.businessPartnerContactCombined?.businessPartner)
      .filter((x) => x)
      .map((x) => x.id)
  ).size <= 1;
